import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    category: 'general'
  });

  const contactEmails = {
    general: { email: 'contact@gpt-jdp.com', label: 'Contacto General', icon: '📧' },
    support: { email: 'support@gpt-jdp.com', label: 'Soporte Técnico', icon: '🆘' },
    billing: { email: 'contact@gpt-jdp.com', label: 'Facturación', icon: '💳' },
    refunds: { email: 'support@gpt-jdp.com', label: 'Reembolsos', icon: '💰' },
    suggestions: { email: 'contact@gpt-jdp.com', label: 'Sugerencias', icon: '💡' },
    complaints: { email: 'ceo@gpt-jdp.com', label: 'Reclamos', icon: '📋' },
    legal: { email: 'ceo@gpt-jdp.com', label: 'Legal', icon: '⚖️' },
    partners: { email: 'contact@gpt-jdp.com', label: 'Alianzas Comerciales', icon: '🤝' },
    ceo: { email: 'ceo@gpt-jdp.com', label: 'Dirección Ejecutiva / Prensa', icon: '👔' }
  };

  const socialLinks = {
    twitter: { url: '#', label: 'Twitter', icon: '𝕏', color: 'bg-black', comingSoon: true },
    instagram: { url: '#', label: 'Instagram', icon: '📷', color: 'bg-pink-600', comingSoon: true },
    linkedin: { url: '#', label: 'LinkedIn', icon: '💼', color: 'bg-blue-700', comingSoon: true },
    facebook: { url: '#', label: 'Facebook', icon: '📘', color: 'bg-blue-600', comingSoon: true },
    youtube: { url: '#', label: 'YouTube', icon: '▶️', color: 'bg-red-600', comingSoon: true }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { email } = contactEmails[formData.category];
    const subject = encodeURIComponent(formData.subject || 'Consulta desde GPT-JDP');
    const body = encodeURIComponent(
      `Nombre: ${formData.name}\nEmail: ${formData.email}\n\nMensaje:\n${formData.message}`
    );
    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
  };

  return (
    <div className="font-display bg-background-light dark:bg-background-dark min-h-screen">
      <div className="px-4 sm:px-10 md:px-20 lg:px-40">
        <Header />
        
        <div className="py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-black text-gray-900 dark:text-white mb-4">
              📧 Contacto
            </h1>
            <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
              Estamos aquí para ayudarte. Elige el canal que mejor se adapte a tu consulta.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            {/* Formulario */}
            <div className="bg-white dark:bg-[#1a2530] rounded-xl p-8 shadow-lg">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
                Envíanos un Mensaje
              </h2>
              
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Categoría
                  </label>
                  <select
                    value={formData.category}
                    onChange={(e) => setFormData({...formData, category: e.target.value})}
                    className="w-full px-4 py-2 border border-gray-300 dark:border-[#283039] rounded-lg bg-white dark:bg-[#283039] text-gray-900 dark:text-white"
                  >
                    {Object.entries(contactEmails).map(([key, value]) => (
                      <option key={key} value={key}>{value.label}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Nombre
                  </label>
                  <input
                    type="text"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    className="w-full px-4 py-2 border border-gray-300 dark:border-[#283039] rounded-lg bg-white dark:bg-[#283039] text-gray-900 dark:text-white"
                    placeholder="Tu nombre"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    className="w-full px-4 py-2 border border-gray-300 dark:border-[#283039] rounded-lg bg-white dark:bg-[#283039] text-gray-900 dark:text-white"
                    placeholder="tu@email.com"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Asunto
                  </label>
                  <input
                    type="text"
                    required
                    value={formData.subject}
                    onChange={(e) => setFormData({...formData, subject: e.target.value})}
                    className="w-full px-4 py-2 border border-gray-300 dark:border-[#283039] rounded-lg bg-white dark:bg-[#283039] text-gray-900 dark:text-white"
                    placeholder="¿En qué podemos ayudarte?"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Mensaje
                  </label>
                  <textarea
                    required
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    rows="5"
                    className="w-full px-4 py-2 border border-gray-300 dark:border-[#283039] rounded-lg bg-white dark:bg-[#283039] text-gray-900 dark:text-white"
                    placeholder="Cuéntanos más sobre tu consulta..."
                  />
                </div>

                <button
                  type="submit"
                  className="w-full px-6 py-3 bg-primary hover:bg-primary-dark text-white font-bold rounded-lg transition-colors"
                >
                  Enviar Mensaje
                </button>

                <p className="text-xs text-gray-500 dark:text-gray-400 text-center">
                  Se abrirá tu cliente de email con los datos prellenados
                </p>
              </form>
            </div>

            {/* Emails directos */}
            <div>
              <div className="bg-white dark:bg-[#1a2530] rounded-xl p-8 shadow-lg mb-6">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
                  Emails Directos
                </h2>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {Object.entries(contactEmails).map(([key, info]) => (
                    <a
                      key={key}
                      href={`mailto:${info.email}`}
                      className="flex items-center gap-3 p-4 border border-gray-200 dark:border-[#283039] rounded-lg hover:border-primary transition-colors"
                    >
                      <span className="text-2xl text-primary">
                        {info.icon}
                      </span>
                      <div>
                        <p className="font-semibold text-gray-900 dark:text-white text-sm">
                          {info.label}
                        </p>
                        <p className="text-xs text-gray-500 dark:text-gray-400">
                          {info.email}
                        </p>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Redes Sociales */}
              <div className="bg-white dark:bg-[#1a2530] rounded-xl p-8 shadow-lg">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
                  Síguenos
                </h2>
                
                <div className="grid grid-cols-2 gap-4">
                  {Object.entries(socialLinks).map(([key, info]) => (
                    <div
                      key={key}
                      className={`${info.color} text-white p-4 rounded-lg flex flex-col items-center justify-center text-center min-h-[120px] ${info.comingSoon ? 'opacity-90' : 'hover:opacity-90 cursor-pointer'}`}
                    >
                      <span className="text-3xl mb-2">{info.icon}</span>
                      <span className="font-semibold text-sm mb-2">{info.label}</span>
                      {info.comingSoon && (
                        <span className="text-xs font-bold bg-orange-500 px-3 py-1 rounded-full mt-1">
                          Próximamente
                        </span>
                      )}
                    </div>
                  ))}
                </div>

                <p className="text-xs text-gray-500 dark:text-gray-400 mt-4 text-center">
                  🚀 Nuestras redes sociales estarán disponibles próximamente
                </p>

                <p className="text-sm text-gray-600 dark:text-gray-400 mt-6 text-center">
                  Respuesta promedio: <strong>24 horas</strong>
                </p>
              </div>
            </div>
          </div>

          {/* Horarios */}
          <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded-xl p-6 text-center">
            <h3 className="font-bold text-blue-900 dark:text-blue-300 mb-2">
              🕐 Horario de Atención
            </h3>
            <p className="text-blue-800 dark:text-blue-300">
              Lunes a Viernes: 9:00 AM - 6:00 PM (CLT - Chile)
            </p>
            <p className="text-sm text-blue-600 dark:text-blue-400 mt-2">
              Emails fuera de horario serán respondidos el siguiente día hábil
            </p>
          </div>
        </div>
        
        <Footer />
      </div>
    </div>
  );
};

export default Contact;
